import React, { Component } from "react";
import LogoAnimation from "../assets/logos/10x_Logo_Animation.mp4";
import VideoOverlay from "./VideoOverlay";

class SplashScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="splash-screen">
        <div className="splash-content">
          <div className="splash-screen genomics-logo">
            <VideoOverlay
              child={this.props.child ? this.props.child : null}
              onEnded={this.props.videoEnded}
              video={LogoAnimation}
              autoPlay={true}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default SplashScreen;
